import { apiRequest } from "./client"

export interface RegisterDeviceResponse {
  success: boolean
  poruka: string
  waiterDeviceId: number
  companyId: number
  poslovnaJedinicaId: number
  kasaId: number
}

export async function registerDevice(setupKey: string, deviceUuid: string, naziv: string): Promise<RegisterDeviceResponse> {
  return apiRequest("/devices/register", { method: "POST", body: { setupKey, deviceUuid, naziv } })
}
